namespace advisorop.components.servicer {

    // Hidden system-admin maintenance page. Hosts one or more maintenance widgets.
    // Access is really enforced by the SYSTEM_ADMIN policy on the API; this guard is cosmetic.
    class AdminMaintenanceController {

        $router;
        user: domains.identity.IUser;
        isAuthorized: boolean;

        static $inject = ["identityService"];
        constructor(private identityService: services.IdentityService) {
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.isAuthorized = (this.user && this.user.username == "00000001");

                if (!this.isAuthorized) {
                    // not the system admin - bounce back to the servicer dashboard
                    try {
                        this.$router.parent.navigate(["Dashboard"]);
                    } catch (e) {
                        // content is hidden by ng-if anyway
                    }
                }
            });
        }

        $routerOnActivate(next, previous) {
        }
    }

    class AdminMaintenance implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AdminMaintenanceController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/admin-maintenance.html';
        }
    }
    angular.module(Constants.APP).component("adminMaintenance", new AdminMaintenance());
}
